import axiosInstance from "auth/FetchInterceptor";
import {
  
  CREATE_COMMON_CATEGORY,
  DELETE_COMMON_CATEGORY,
  GET_ALL_COMMON_CATEGORY,
  UPDATE_PRIORITY_COMMON_CATEGORY,
  UPDATE_COMMON_CATEGORY
} from "constants/ApiConstant";

const CommonCategoryService = {};

CommonCategoryService.getAll = function (params) {
  return axiosInstance.post(GET_ALL_COMMON_CATEGORY, params);
};

CommonCategoryService.create = function (data) {
  return axiosInstance.post(CREATE_COMMON_CATEGORY, data);
};

CommonCategoryService.update = function (data) {
  return axiosInstance.put(UPDATE_COMMON_CATEGORY, data);
};

CommonCategoryService.updatePriority = function (data) {
  return axiosInstance.put(UPDATE_PRIORITY_COMMON_CATEGORY, data);
};


CommonCategoryService.delete = function (id) {
  return axiosInstance.delete(`${DELETE_COMMON_CATEGORY}/${id}`);
};

export default CommonCategoryService;